import { ForwardedRef, forwardRef } from 'react'
import { Renderable } from '../classes/renderer'
import { useImage } from '../hooks/use-image'
import { ArtboardImageLayerProps } from '../types'
import ArtboardTexture from './texture'

const ArtboardImage = ({ source, ...rest }: ArtboardImageLayerProps, ref: ForwardedRef<Renderable>) => {
    const img = useImage(source)

    return <ArtboardTexture {...rest} ref={ref} source={img} />
}

export default forwardRef(ArtboardImage)
